// extracted by mini-css-extract-plugin
export default {"discountCode":"checkout-coupon-applied_discountCode__AAxOe"};